import { createRouter } from "@agportal/router";
import { createEditingGuard } from "@dmvs/composables/editingtracker";
import { createGroupGuard } from "@dmvs/composables/routing";
import { useSecurityContext } from "@dmvs/composables/security";
import { routes as common } from "@dmvs/router";
import { concat } from "lodash-es";

import { createSecurityGuard } from "@/security";

const router = createRouter({
    routes: concat(
        [],
        [
            {
                path: "/",
                name: "uvod",
                redirect: {
                    path: "/portal",
                },
            },
            {
                path: "/portal",
                name: "portal",
                component: () => import("@/views/Uvod"),
                meta: {
                    title: "Úvod",
                    breadcrumbs: false,
                },
            },
            {
                path: "/portal/registrace",
                name: "registrace-old",
                component: () => import("@/views/Registrace"),
                meta: {
                    label: "Registrace",
                    breadcrumbs: true,
                    secured: true,
                },
                redirect: {
                    name: "registrace",
                },
            },
            {
                path: "/portal/povereni-uzivatele",
                name: "povereni-uzivatele",
                component: () => import("@/views/PovereniUzivatele"),
                meta: {
                    label: "Pověření uživatele",
                    title: "Pověření uživatele",
                    secured: true,
                    editable: true,
                },
            },
            {
                path: "/portal/povereni-editora-dti",
                name: "povereni-editora-dti",
                component: () => import("@/views/PovereniEditoraDti"),
                meta: {
                    label: "Pověření editora",
                    title: "Pověření editora",
                    secured: true,
                    editable: true,
                },
            },
            {
                path: "/portal/povereni-editora-zps",
                name: "povereni-editora-zps",
                component: () => import("@/views/PovereniEditoraZps"),
                meta: {
                    label: "Pověření editora ZPS",
                    title: "Pověření editora ZPS",
                    secured: true,
                    editable: true,
                },
            },
            {
                path: "/portal/zmena-uzemi-editace-zps",
                name: "zmena-uzemi-editace-zps",
                component: () => import("@/views/ZmenaUzemiEditaceZps"),
                meta: {
                    label: "Změna území editace ZPS",
                    title: "Změna území editace ZPS",
                    secured: true,
                    editable: true,
                },
            },
            {
                path: "/portal/povereni-zakladatele",
                name: "povereni-zakladatele",
                component: () => import("@/views/PrirazeniZakladatele"),
                meta: {
                    label: "Pověření zakladatele",
                    title: "Pověření zakladatele",
                    secured: true,
                    editable: true,
                },
            },
            {
                path: "/portal/povereni-subjektu",
                name: "povereni-subjektu",
                component: () => import("@/views/PovereniSubjektu"),
                meta: {
                    label: "Pověření subjektu",
                    title: "Pověření subjektu",
                    secured: true,
                    editable: true,
                },
            },
            {
                path: "/portal/povereni-vyjadrovatele",
                name: "povereni-vyjadrovatele",
                component: () => import("@/views/PovereniVyjadrovatele"),
                meta: {
                    label: "Pověření vyjadřovatele",
                    title: "Pověření vyjadřovatele",
                    secured: true,
                    editable: true,
                },
            },
            {
                path: "/portal/pozadavek-na-registraci",
                name: "pozadavek-na-registraci",
                component: () => import("@/views/PozadavekNaRegistraci"),
                meta: {
                    label: "Požadavek na registraci",
                    title: "Požadavek na registraci",
                    secured: true,
                },
            },
            {
                path: "/portal/subjekty",
                name: "subjekty",
                component: () => import("@/views/RozcestnikSubjekty"),
                meta: {
                    label: "Subjekty DMVS",
                    title: "Subjekty DMVS",
                    breadcrumbs: true,
                    secured: true,
                },
                children: [
                    {
                        path: "registrace",
                        name: "registrace",
                        component: () => import("@/views/Registrace"),
                        meta: {
                            title: "Registrace do IS DMVS",
                            label: "Registrace do IS DMVS",
                            editable: true,
                        },
                    },
                    {
                        path: "sprava-subjektu",
                        name: "sprava-subjektu",
                        component: () => import("@/views/SpravaSubjektu"),
                        redirect: {
                            name: "informace-o-subjektu",
                        },
                        meta: {
                            label: "Správa subjektu",
                            group: "sprava-subjektu",
                        },
                        children: [
                            {
                                path: "informace",
                                name: "informace-o-subjektu",
                                component: () => import("@/components/composition/InformaceSubjektu"),
                                meta: {
                                    label: "Informace",
                                    title: "Informace subjektu",
                                    editable: true,
                                },
                            },
                            {
                                path: "notifikace-subjektu",
                                name: "notifikace-subjektu",
                                component: () => import("@/components/composition/NastaveniNotifikaciSubjektu"),
                                meta: {
                                    label: "Notifikace",
                                    title: "Notifikace subjektu",
                                    editable: true,
                                },
                            },
                            {
                                path: "registry",
                                name: "registry-subjektu",
                                component: () => import("@/components/composition/RegistrySubjektu"),
                                meta: {
                                    label: "Registry",
                                    title: "Registry subjektu",
                                    editable: true,
                                },
                            },
                            {
                                path: "dtm",
                                name: "dtm",
                                component: () => import("@/components/composition/InformaceIsDtm"),
                                meta: {
                                    label: "DTM",
                                    title: "Subjekt DTM",
                                    editable: true,
                                },
                            },
                            {
                                path: "zps",
                                name: "zps",
                                component: () => import("@/components/composition/InformaceEditoraZps"),
                                meta: {
                                    label: "Editor ZPS",
                                    title: "Editor ZPS",
                                    editable: true,
                                },
                            },
                            {
                                path: "povereni",
                                name: "povereni",
                                component: () => import("@/components/composition/UzivateleSubjektu"),
                                meta: {
                                    label: "Pověření",
                                    title: "Pověření subjektu",
                                    editable: true,
                                },
                            },
                        ],
                    },
                ],
            },
            {
                path: "/portal/dti",
                name: "dti",
                component: () => import("@/views/RozcestnikDti"),
                meta: {
                    label: "Dopravní a technická infrastruktura",
                    title: "Dopravní a technická infrastruktura",
                    breadcrumbs: true,
                    secured: true,
                },
                children: [
                    {
                        path: "casti-dti",
                        name: "casti-dti",
                        component: () => import("@/views/CastiDti"),
                        meta: {
                            label: "Části DTI",
                            title: "Části DTI",
                            group: "casti-dti",
                            breadcrumbs: true,
                            secured: true,
                            editable: true,
                        },
                        children: [
                            {
                                path: ":castDtiId",
                                name: "detail-casti-dti",
                                meta: {
                                    label: "#{castDti}",
                                },
                                component: () => import("@/views/DetailCastiDti"),
                                redirect: {
                                    name: "informace-casti-dti",
                                },
                                children: [
                                    {
                                        path: "informace",
                                        name: "informace-casti-dti",
                                        component: () => import("@/components/composition/InformaceCastiDti"),
                                        meta: {
                                            label: "Informace",
                                            title: "Informace části DTI",
                                            editable: true,
                                        },
                                    },
                                    {
                                        path: "vyjadrovatel",
                                        name: "vyjadrovatel",
                                        component: () => import("@/components/composition/Vyjadrovatel"),
                                        meta: {
                                            label: "Vyjadřovatel",
                                            title: "Vyjadřovatel části DTI",
                                            editable: true,
                                        },
                                    },
                                    {
                                        path: "kontaktni-udaje",
                                        name: "kontaktni-udaje-casti-dti",
                                        component: () => import("@/components/composition/KontaktniUdajeCastiDti"),
                                        meta: {
                                            label: "Kontaktní údaje",
                                            tooltip: "Kontaktní údaje pro podání žádosti o stanovisko",
                                            title: "Kontaktní údaje části DTI",
                                            editable: true,
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: "rozsahy-editace-dti",
                        name: "rozsahy-editace-dti",
                        component: () => import("@/views/RozsahyEditaceDti"),
                        meta: {
                            label: "Rozsahy editace DTI",
                            title: "Rozsahy editace DTI",
                            group: "rozsahy-editace-dti",
                            breadcrumbs: true,
                            secured: true,
                            editable: true,
                        },
                        children: [
                            {
                                path: ":rozsahDtiId",
                                name: "detail-rozsahu-dti",
                                meta: {
                                    label: "#{rozsahDti}",
                                },
                                component: () => import("@/views/DetailRozsahuEditaceDti"),
                                redirect: {
                                    name: "informace-rozsahu-dti",
                                },
                                children: [
                                    {
                                        path: "informace",
                                        name: "informace-rozsahu-dti",
                                        component: () => import("@/components/composition/InformaceRozsahuDti"),
                                        meta: {
                                            label: "Informace",
                                            title: "Informace rozsahu editace DTI",
                                            editable: true,
                                        },
                                    },
                                    {
                                        path: "editori",
                                        name: "editori-rozsahu-dti",
                                        component: () => import("@/components/composition/Editori"),
                                        meta: {
                                            label: "Editoři",
                                            title: "Editoři rozsahu editace DTI",
                                            editable: true,
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: "vydej-vsp",
                        name: "vydej-vsp",
                        component: () => import("@/views/RozcestnikVsp"),
                        meta: {
                            label: "Výdej vlastních dat VSP",
                            title: "Výdej vlastních dat VSP",
                        },
                        children: [
                            {
                                path: "vydej",
                                name: "vydej-vsp-zadost",
                                component: () => import("@/views/VydejDatVsp"),
                                meta: {
                                    label: "Žádost o vlastní data VSP",
                                    title: "Žádost o vlastní data VSP",
                                    secured: true,
                                    editable: true,
                                },
                            },
                            {
                                path: "zadosti",
                                name: "vydej-vsp-prehled",
                                component: () => import("@/views/PrehledZadostiVydejeVlastnichDat"),
                                meta: {
                                    label: "Přehled žádostí",
                                    title: "Přehled žádostí o výdej vlastních dat VSP",
                                    group: "zadosti-o-vydej-vlastnich-dat",
                                    secured: true,
                                },
                                children: [
                                    {
                                        path: ":zadostId",
                                        name: "vydej-vsp-detail",
                                        meta: {
                                            label: "#{zadostId}",
                                            title: "Detail žádosti o vlastní data VSP",
                                        },
                                        component: () => import("@/views/DetailZadostiVydejeVlastnichDat"),
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: "uzemi-spravcu-dti",
                        name: "uzemi-spravcu-dti",
                        component: () => import("@/views/RozcestnikZjisteniUzemi"),
                        meta: {
                            label: "Zjištění území správců DTI",
                            title: "Zjištění území správců DTI",
                            secured: true,
                        },
                        children: [
                            {
                                path: "zadost",
                                name: "zjisteni-uzemi-zadost",
                                component: () => import("@/views/ZjisteniUzemiSpravcuDti"),
                                meta: {
                                    label: "Žádost o zjištění území správců DTI",
                                    title: "Žádost o zjištění území správců DTI",
                                    editable: true,
                                },
                            },
                            {
                                path: "zadosti",
                                name: "zjisteni-uzemi-prehled",
                                component: () => import("@/views/PrehledZadostiZjisteniUzemi"),
                                meta: {
                                    label: "Přehled žádostí",
                                    title: "Přehled žádostí o zjištění území správců DTI",
                                    group: "zadosti-zjisteni-uzemi",
                                },
                                children: [
                                    {
                                        path: ":zadostId",
                                        name: "zjisteni-uzemi-detail",
                                        meta: {
                                            label: "Žádost o zjištění území správců DTI",
                                            title: "Detail žádosti o zjištění území správců DTI",
                                        },
                                        component: () => import("@/views/DetailZadostiZjisteniUzemi"),
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: "subjekty",
                        name: "vyhledavani-subjektu-dti",
                        component: () => import("@/views/VyhledavaniSubjektuDti"),
                        meta: {
                            label: "Vyhledávání VSP a editorů DTI",
                            title: "Vyhledávání VSP a editorů DTI",
                            group: "vyhledavani-subjektu-dti",
                            breadcrumbs: true,
                            secured: true,
                        },
                        children: [
                            {
                                path: ":subjektUid",
                                name: "vyhledavani-subjektu-detail",
                                meta: {
                                    label: "#{subjekt}",
                                    title: "Detail subjektu",
                                },
                                component: () => import("@/views/DetailVyhledanehoSubjektu"),
                            },
                        ],
                    },
                ],
            },
            // GAD routes for users registered in AZI register
            {
                path: "/portal/gad",
                name: "gad",
                component: () => import("@/views/RozcestnikGad"),
                meta: {
                    label: "Geodetická aktualizační dokumentace",
                    title: "Geodetická aktualizační dokumentace",
                    breadcrumbs: true,
                    secured: true,
                },
                children: [
                    {
                        path: "stav-zpracovani",
                        name: "gad-stav-zpracovani",
                        component: () => import("@/views/StavPodaniGad"),
                        meta: {
                            label: "Zjištění stavu zpracování GAD",
                            title: "Zjištění stavu zpracování GAD",
                        },
                    },
                    {
                        path: "kontrola-dat",
                        name: "gad-kontrola-dat",
                        component: () => import("@/views/KontrolniZaslaniGad"),
                        meta: {
                            label: "Kontrolní zaslání dat",
                            title: "Kontrolní zaslání dat",
                            editable: true,
                        },
                    },
                    {
                        path: "aktualizace-dat",
                        name: "gad-aktualizace-dat",
                        component: () => import("@/views/ZaslaniZmenyGad"),
                        meta: {
                            label: "Požadavek na změnu",
                            title: "Požadavek na změnu GAD",
                            editable: true,
                        },
                    },
                    {
                        path: "podani",
                        name: "podani-gad",
                        component: () => import("@/views/PodaniGad"),
                        meta: {
                            label: "Přehled podání",
                            title: "Přehled podání GAD",
                            group: "podani-gad",
                        },
                        children: [
                            {
                                path: ":idPodani",
                                name: "detail-podani-gad",
                                meta: {
                                    label: "#{idPodani}",
                                    title: "Detail podání GAD",
                                },
                                component: () => import("@/views/DetailPodaniGad"),
                            },
                        ],
                    },
                ],
            },
            {
                path: "/portal/stav-zpracovani-gad",
                name: "stav-zpracovani-gad-old",
                component: () => import("@/views/StavPodaniGad"),
                meta: {
                    label: "Stav zpracování",
                    secured: true,
                },
                redirect: {
                    name: "gad-stav-zpracovani",
                },
            },
            {
                path: "/portal/psp",
                name: "psp",
                component: () => import("@/views/RozcestnikPsp"),
                meta: {
                    label: "Plánované stavební práce",
                    title: "Plánované stavební práce",
                    breadcrumbs: true,
                    secured: true,
                },
                beforeEnter: (to, from, next) => {
                    const { details } = useSecurityContext();

                    if (!details.value.isPsiAllowed) {
                        next({ name: "uvod" });
                    } else {
                        next();
                    }
                },
                children: [
                    {
                        path: "evidence-psp",
                        name: "evidence-psp",
                        component: () => import("@/views/EvidencePsp"),
                        meta: {
                            label: "Evidence PSP",
                            title: "Evidence PSP",
                            group: "evidence-psp",
                            editable: true,
                        },
                        children: [
                            {
                                path: ":subjektId/:stavbaId",
                                name: "detail-psp",
                                meta: {
                                    label: "#{stavba}",
                                },
                                component: () => import("@/views/DetailPsp"),
                                redirect: {
                                    name: "informace-psp",
                                },
                                children: [
                                    {
                                        path: "informace",
                                        name: "informace-psp",
                                        component: () => import("@/components/composition/InformacePsp"),
                                        meta: {
                                            label: "Informace",
                                            title: "Informace PSP",
                                            editable: true,
                                        },
                                    },
                                    {
                                        path: "harmonogram-stavby",
                                        name: "harmonogram-stavby",
                                        component: () => import("@/components/composition/HarmonogramPsp"),
                                        meta: {
                                            label: "Harmonogram stavby",
                                            title: "Harmonogram PSP",
                                            editable: true,
                                        },
                                    },
                                    {
                                        path: "kontaktni-udaje",
                                        name: "kontaktni-udaje-psp",
                                        component: () => import("@/components/composition/KontaktniUdajePsp"),
                                        meta: {
                                            label: "Kontaktní údaje",
                                            title: "Kontaktní údaje správce PSP",
                                            editable: true,
                                        },
                                    },
                                    {
                                        path: "prilohy",
                                        name: "prilohy-psp",
                                        component: () => import("@/components/composition/PrilohyPsp"),
                                        meta: {
                                            label: "Přílohy",
                                            title: "Přílohy PSP",
                                            editable: true,
                                        },
                                    },
                                    {
                                        path: "editace-obsahu",
                                        component: () => import("@/components/composition/ObsahPsp"),
                                        meta: {
                                            label: "Editace obsahu",
                                            title: "Editace obsahu PSP",
                                            editable: true,
                                        },
                                    },
                                    {
                                        path: "notifikace",
                                        name: "notifikace-psp",
                                        component: () => import("@/components/composition/NotifikacePsp"),
                                        meta: {
                                            label: "Notifikace",
                                            title: "Notifikace PSP",
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: "prehled-psp",
                        name: "prehled-psp",
                        component: () => import("@/views/PrehledPspOvm"),
                        meta: {
                            label: "Přehled PSP",
                            title: "Přehled PSP",
                            group: "prehled-psp",
                        },
                        children: [
                            {
                                path: ":stavbaId",
                                name: "detail-psp-ovm",
                                meta: {
                                    label: "#{stavba}",
                                },
                                component: () => import("@/views/DetailPspOvm"),
                                redirect: {
                                    name: "informace-psp-ovm",
                                },
                                children: [
                                    {
                                        path: "informace",
                                        name: "informace-psp-ovm",
                                        component: () => import("@/components/composition/InformacePsp"),
                                        meta: {
                                            label: "Informace",
                                            title: "Informace PSP",
                                        },
                                    },
                                    {
                                        path: "harmonogram-stavby",
                                        component: () => import("@/components/composition/HarmonogramPsp"),
                                        meta: {
                                            label: "Harmonogram stavby",
                                            title: "Harmonogram PSP",
                                        },
                                    },
                                    {
                                        path: "kontaktni-udaje",
                                        component: () => import("@/components/composition/KontaktniUdajePsp"),
                                        meta: {
                                            label: "Kontaktní údaje",
                                            title: "Kontaktní údaje správce PSP",
                                        },
                                    },
                                    {
                                        path: "prilohy",
                                        component: () => import("@/components/composition/PrilohyPsp"),
                                        meta: {
                                            label: "Přílohy",
                                            title: "Přílohy PSP",
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: "editace-obsahu",
                        name: "editace-obsahu-psp",
                        component: () => import("@/views/PrehledEditaciObsahuPsp"),
                        meta: {
                            label: "Přehled editací obsahu PSP",
                            title: "Přehled editací obsahu PSP",
                            group: "editace-obsahu-psp",
                        },
                        children: [
                            {
                                path: ":subjektId/:editaceId",
                                name: "detail-editace-obsahu-psp",
                                meta: {
                                    label: "#{idPodani}",
                                    title: "Detail editace obsahu PSP",
                                },
                                component: () => import("@/views/DetailEditaceObsahuPsp"),
                            }
                        ]
                    },
                    {
                        path: "vydej-vlastnich-dat-psp",
                        name: "vydej-vlastnich-psp",
                        component: () => import("@/views/RozcestnikVydejVlastnichPsp"),
                        meta: {
                            label: "Výdej vlastních dat PSP",
                            title: "Výdej vlastních dat PSP",
                        },
                        children: [
                            {
                                path: "vydej",
                                name: "vydej-vlastnich-psp-zadost",
                                component: () => import("@/views/VydejVlastnichPsp"),
                                meta: {
                                    label: "Žádost o výdej vlastních dat PSP",
                                    title: "Žádost o výdej vlastních dat PSP",
                                    editable: true,
                                },
                            },
                            {
                                path: "zadosti",
                                name: "vydej-vlastnich-psp-prehled",
                                component: () => import("@/views/PrehledZadostiVydejeVlastnichPsp"),
                                meta: {
                                    label: "Přehled žádostí",
                                    title: "Přehled žádostí o výdej vlastních PSP",
                                    group: "zadosti-o-vydej-vlastnich-psp",
                                },
                                children: [
                                    {
                                        path: ":zadostId",
                                        name: "vydej-vlastnich-psp-detail",
                                        meta: {
                                            label: "#{zadostId}",
                                            title: "Detail žádosti o vlastní data PSP",
                                        },
                                        component: () => import("@/views/DetailZadostiVydejeVlastnichPsp"),
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                path: "/portal/vydej-dat",
                name: "vydej-dat",
                component: () => import("@/views/RozcestnikVydejDat"),
                meta: {
                    label: "Výdej dat DTM",
                    title: "Výdej dat DTM",
                    breadcrumbs: true,
                },
                children: [
                    {
                        path: "verejne-datove-sady",
                        name: "verejne-datove-sady",
                        component: () => import("@/views/OpenData"),
                        meta: {
                            label: "Veřejné datové sady",
                            title: "Veřejné datové sady",
                        },
                    },
                    {
                        path: "predpripravene-datove-sady",
                        name: "predpripravene-datove-sady",
                        component: () => import("@/views/VydejPreddefinovanychDatovychSad"),
                        meta: {
                            label: "Výdej předpřipravených datových sad",
                            title: "Výdej předpřipravených datových sad",
                            secured: true,
                            editable: true,
                        },
                    },
                    {
                        path: "data-v-definovanem-uzemi",
                        name: "data-v-definovanem-uzemi",
                        component: () => import("@/views/VyhotoveniDatovychSad"),
                        meta: {
                            label: "Výdej dat v definovaném území",
                            title: "Výdej dat v definovaném území",
                            secured: true,
                            editable: true,
                        },
                    },
                    {
                        path: "zadosti",
                        name: "zadosti",
                        component: () => import("@/views/PrehledZadostiVydejeDat"),
                        meta: {
                            label: "Přehled žádostí",
                            title: "Přehled žádostí o výdej dat",
                            group: "zadosti-o-vydej-dat",
                            secured: true,
                        },
                        children: [
                            {
                                path: ":typZadosti/:zadostId",
                                name: "detail-zadosti",
                                meta: {
                                    label: "#{zadostId}",
                                    title: "Detail žádosti o výdej dat",
                                },
                                component: () => import("@/views/DetailZadostiVydejeDat"),
                            },
                        ],
                    },
                ],
            },
            {
                path: "/portal/vydej-dat-psp",
                name: "vydej-dat-psp",
                component: () => import("@/views/RozcestnikVydejDatPsp"),
                meta: {
                    label: "Výdej dat PSP",
                    title: "Výdej dat PSP",
                    breadcrumbs: true,
                    secured: true,
                },
                beforeEnter: (to, from, next) => {
                    const { details } = useSecurityContext();

                    if (!details.value.isPsiAllowed) {
                        next({ name: "uvod" });
                    } else {
                        next();
                    }
                },
                children: [
                    {
                        path: "predpripravene-datove-sady",
                        name: "predpripravene-datove-sady-psp",
                        component: () => import("@/views/VydejPreddefinovanychDatovychSadPsp"),
                        meta: {
                            label: "Výdej předpřipravených datových sad PSP",
                            title: "Výdej předpřipravených datových sad PSP",
                            editable: true,
                        },
                    },
                    {
                        path: "data-v-definovanem-uzemi",
                        name: "data-psp-v-definovanem-uzemi",
                        component: () => import("@/views/VyhotoveniDatPsp"),
                        meta: {
                            label: "Výdej dat PSP v definovaném území",
                            title: "Výdej dat PSP v definovaném území",
                            editable: true,
                        },
                    },
                    {
                        path: "zadosti",
                        name: "vydej-dat-psp-zadosti",
                        component: () => import("@/views/PrehledZadostiVydejeDatPsp"),
                        meta: {
                            label: "Přehled žádostí o výdej dat PSP",
                            title: "Přehled žádostí o výdej dat PSP",
                            group: "zadosti-o-vydej-dat-psp",
                        },
                        children: [
                            {
                                path: ":typZadosti/:zadostId",
                                name: "vydej-dat-psp-detail",
                                meta: {
                                    label: "#{zadostId}",
                                    title: "Detail žádosti o data PSP",
                                },
                                component: () => import("@/views/DetailZadostiVydejeDatPsp"),
                            },
                        ],
                    },
                ],
            },
            {
                path: "/portal/uzemi-spravcu-dti",
                name: "uzemi-spravcu-dti-old",
                component: () => import("@/views/ZjisteniUzemiSpravcuDti"),
                meta: {
                    label: "Zjištění území správců dopravní a technické infrastruktury",
                    secured: true,
                },
                redirect: {
                    name: "uzemi-spravcu-dti",
                },
            },
            {
                path: "/portal/jvf",
                name: "jvf",
                component: () => import("@/views/RozcestnikJvf"),
                meta: {
                    label: "JVF DTM",
                    title: "JVF DTM",
                    group: "jvf",
                    breadcrumbs: true,
                    secured: true,
                },
                children: [
                    {
                        path: "verze-jvf",
                        name: "verze-jvf",
                        component: () => import("@/views/Jvf"),
                        meta: {
                            label: "Verze JVF",
                            title: "Verze JVF",
                        },
                    },
                    {
                        path: "validace-jvf",
                        name: "validace-jvf",
                        component: () => import("@/views/ValidaceJvf"),
                        meta: {
                            label: "Validace JVF souboru",
                            title: "Validace JVF souboru",
                            editable: true,
                        },
                    },
                    {
                        path: "pozadavky-validace-jvf",
                        name: "pozadavky-validace-jvf",
                        component: () => import("@/views/PrehledPozadavkuNaValidaciJvf"),
                        meta: {
                            label: "Přehled požadavků na validaci JVF",
                            title: "Přehled požadavků na validaci JVF",
                            group: "pozadavky-validace-jvf",
                        },
                        children: [
                            {
                                path: ":subjektId/:pozadavekId",
                                name: "detail-pozadavku-validace",
                                meta: {
                                    label: "#{typPozadavku}",
                                    title: "Detail požadavku na validaci JVF",
                                },
                                component: () => import("@/views/DetailPozadavkuValidaceDat"),
                            },
                        ],
                    },
                ],
            },
            {
                path: "/portal/prehledy-ciselniky",
                name: "prehledy-ciselniky",
                component: () => import("@/views/RozcestnikCiselniky"),
                meta: {
                    label: "Přehledy a číselníky",
                    title: "Přehledy a číselníky",
                    breadcrumbs: true,
                    secured: true,
                },
                children: [
                    {
                        path: "ciselniky",
                        name: "ciselniky",
                        component: () => import("@/views/Ciselniky"),
                        meta: {
                            label: "Seznam číselníků",
                            title: "Seznam číselníků",
                        },
                    },
                    {
                        path: "certifikaty",
                        name: "certifikaty",
                        component: () => import("@/views/Certifikaty"),
                        meta: {
                            label: "Certifikáty",
                            title: "Certifikáty",
                        },
                    },
                    {
                        path: "azi",
                        name: "azi",
                        component: () => import("@/views/Azi"),
                        meta: {
                            label: "Autorizovaní zeměměřičtí inženýři",
                            title: "Autorizovaní zeměměřičtí inženýři",
                        },
                    },
                ],
            },
            {
                path: "/portal/systemove-informace",
                name: "systemove-informace",
                component: () => import("@/views/RozcestnikSystemoveInformace"),
                meta: {
                    label: "Systémové informace",
                    title: "Systémové informace",
                    breadcrumbs: true,
                },
                children: [
                    {
                        path: "informace-o-systemu",
                        name: "informace-o-systemu",
                        component: () => import("@/views/InformaceOSystemu"),
                        meta: {
                            label: "Informace o systému",
                            title: "Informace o systému",
                            group: "informace-o-systemu",
                        },
                        children: [
                            {
                                path: ":uuid",
                                name: "detail-informace-o-systemu",
                                component: () => import("@/views/DetailInformaceOSystemu"),
                                meta: {
                                    label: "#{titulek}",
                                    title: "Detail informace o systému",
                                },
                            },
                        ],
                    },
                    {
                        path: "stav-is-dtm-kraju",
                        name: "stav-is-dtm-kraju",
                        component: () => import("@/views/StavIsDtmKraju"),
                        meta: {
                            label: "Stav IS DTM krajů",
                            title: "Stav IS DTM krajů",
                        },
                    },
                ],
            },
            {
                path: "/portal/notifikace",
                name: "notifikace",
                component: () => import("@/views/Notifikace"),
                meta: {
                    label: "Notifikace",
                    title: "Notifikace",
                    breadcrumbs: true,
                    secured: true,
                    group: "notifikace",
                },
            },
            {
                path: "/mapovy-portal",
                name: "mapovy-portal",
                component: () => import("@/views/RozcestnikMapovyPortal"),
                meta: {
                    label: "Mapový portál",
                    title: "Mapový portál",
                    breadcrumbs: false,
                },
                children: [
                    {
                        path: "mapa",
                        name: "detail-mapovy-portal",
                        meta: {
                            label: "Mapa",
                            title: "Mapový portál",
                            fullwidth: true,
                        },
                        component: () => import("@/views/MapovyPortal"),
                    },
                ],
            },
            {
                path: "/informace-o-dmvs",
                name: "informace-o-dmvs",
                component: () => import("@/views/InformaceODmvs"),
                meta: {
                    label: "Informace o DMVS",
                    title: "Informace o DMVS",
                    breadcrumbs: false,
                },
            },
            {
                path: "/dtmk",
                name: "dtmk",
                component: () => import("@/views/RozcestnikDtmk"),
                meta: {
                    label: "DTMK",
                    title: "DTMK",
                    breadcrumbs: false,
                    secured: true,
                    wide: true,
                },
                children: [
                    {
                        path: "ulohy",
                        name: "dtmk-ulohy",
                        meta: {
                            label: "Úlohy",
                            title: "Úlohy",
                            breadcrumbs: true,
                            group: "dtmk",
                            wide: true,
                        },
                        component: () => import("@/views/UlohyDtmk"),
                        children: [
                            {
                                path: ":typUlohy/:zadostId",
                                name: "detail-ulohy-dtmk",
                                meta: {
                                    label: "#{typUlohy}",
                                    title: "Detail úlohy DTMK",
                                    wide: true,
                                },
                                component: () => import("@/views/DetailUlohyDtmk"),
                            },
                        ],
                    },
                ],
            },
            {
                path: "/prohlaseni-o-pristupnosti",
                name: "prohlaseni-o-pristupnosti",
                component: () => import("@/views/ProhlaseniOPristupnosti"),
                meta: {
                    label: "Prohlášení o přístupnosti",
                    title: "Prohlášení o přístupnosti",
                    breadcrumbs: true,
                },
            },
            {
                path: "/rss",
                name: "rss",
                component: () => import("@/views/SeznamRssKanalu"),
                meta: {
                    label: "RSS kanály",
                    title: "RSS kanály",
                    breadcrumbs: true,
                },
            },
        ],
        common
    ),
});

router.beforeEach(createSecurityGuard());
router.beforeEach(createGroupGuard());
router.beforeEach(createEditingGuard());

router.afterEach((to) => {
    document.title = [to.meta.title, "Portál DMVS (ČÚZK)"].filter(Boolean).join(" | ");
});

export default router;
